export const WE_SAVE_PARAMETERS = 'WE_SAVE_PARAMETERS';
export const INIT_DATA = 'INIT_FILE_MONITORING_DATA';
export const FETCH_EXISTING_RESULTS = 'FETCH_EXISTING_RESULTS';
export const FETCH_RESULTS = 'FETCH_RESULTS';
export const GET_HEADER_TO_DISPLAY = 'GET_FILE_MONITORING_HEADER_TO_DISPLAY';
export const GET_COLUMNS = 'GET_FILE_MONITORING_COLUMNS';
